import { TableBody, TableCell, TableRow } from '@/components/ui';
import { Skeleton } from '@/components/custom';

const DataTableBodySkeleton = ({ rows = 8 }: { rows?: number }) => {
	const keys = Array.from({ length: rows }, () => crypto.randomUUID());

	return (
		<TableBody>
			{keys.map(key => (
				<TableRow key={key} className="h-14">
					<TableCell className="py-2">
						<Skeleton className="h-4 w-32" />
					</TableCell>
					<TableCell className="py-2">
						<Skeleton className="h-5 w-24 rounded-md" />
					</TableCell>
					<TableCell className="py-2">
						<Skeleton className="h-4 w-16" />
					</TableCell>
					<TableCell className="py-2">
						<Skeleton className="h-4 w-36" />
					</TableCell>
					<TableCell className="py-2">
						<Skeleton className="h-4 w-14" />
					</TableCell>
					<TableCell className="py-2">
						<Skeleton className="h-5 w-20 rounded-full" />
					</TableCell>
					<TableCell className="py-2 text-right">
						<Skeleton className="ml-auto h-8 w-24 rounded" />
					</TableCell>
				</TableRow>
			))}
		</TableBody>
	);
};

export default DataTableBodySkeleton;
